module.exports = __webpack_public_path__ + "img/inspiration-3@2x.c0ec8d6.jpg";